import { useEffect, useRef, useState } from 'react';

function useIsMounted(callback?: () => void) {
  const [isMounted, setIsMounted] = useState(false);
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current) {
      setIsMounted(true);
      callback?.();
      hasRun.current = true;
    }
  }, []);

  return isMounted;
}

export default useIsMounted;